export const sliceListAroundIndex = ({ list, index, maxSize }) => {
  const step = Math.trunc(maxSize / 2)
  let startSlice = 0
  if (list.size > maxSize && index - step > 0) {
    if (list.size - index > step) {
      startSlice = index - step
    } else {
      startSlice = list.size - maxSize
    }
  }
  const updatedIndex = index - startSlice
  const endSlice = startSlice + maxSize
  return {
    slicedList: list.slice(startSlice, endSlice),
    updatedIndex,
  }
}
